import { UserContext, UserContextProps } from '@/utils/providers/userContext/UserContext.tsx';
import { useContext } from 'react';

export const useUserContext = (): UserContextProps => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};
